import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { renderErrorStateIcon } from 'apps/webcomponents/src/utils/widgets.utils';

export const templateEndpointModules = document.createElement('template');

templateEndpointModules.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-2-3-ratio">
    <h2 class="display-2 widget-title">
        <span id="endpointModulesTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content">
      <div class="content-tables">
        <gz-table id="modulesDetailsLeft" class="moduleDetailsTable"></gz-table>
        <gz-table id="modulesDetailsRight" class="moduleDetailsTable"></gz-table>
      </div>
      <div class="legend"></div>
      <gz-loader class="widget-loading" rows="5"></gz-loader>
    </div>
  </div>
`;
